import { z } from 'zod';

import { requiredFieldError, validateExpense } from '../../helper';
import { Period } from '../../types';
import { amountApplicable } from './amount';

export const expense = z.object({
  mortgage: amountApplicable.superRefine((data, ctx) => validateExpense({ data, ctx })),
  rent: amountApplicable.superRefine((data, ctx) => validateExpense({ data, ctx })),
  household: amountApplicable
    .default({ amount: 0, period: Period.Monthly })
    .superRefine((data, ctx) => validateExpense({ data, ctx, isMonthlyExpense: true })),
  otherLoans: amountApplicable
    .default({ amount: 0, period: Period.Monthly })
    .superRefine((data, ctx) => validateExpense({ data, ctx, isMonthlyExpense: true })),
  creditCards: z
    .object({
      limit: z.number().optional(),
      isNotApplicable: z.boolean().optional(),
    })
    .transform((data) => {
      if (data.isNotApplicable) {
        return { ...data, limit: 0 };
      }
      return data;
    })
    .superRefine((data, ctx) => {
      const { isNotApplicable, limit } = data;
      if (!isNotApplicable && (!limit || limit <= 0)) {
        ctx.addIssue({
          code: z.ZodIssueCode.too_small,
          minimum: 1,
          type: 'number',
          inclusive: true,
          message: requiredFieldError(),
          path: ['limit'],
        });
      }
    }),
});
